export const OPTION_FIELD_TYPES = ['select', 'multi_select', 'radio', 'checkbox'];

export const LOCATION_FIELD_SLUGS = ['location', 'city', 'state', 'latitude', 'longitude'];

export const TEXT_INPUT_FIELD_TYPES = ['text', 'email', 'phone', 'url', 'number', 'date'];

export const TEXTAREA_FIELD_TYPE = 'textarea';

export const INPUT_TYPE_MAP = {
	text: 'text',
	email: 'email',
	phone: 'tel',
	url: 'url',
	number: 'number',
	date: 'date',
};

export const normalizeFieldOptions = (options) => {
	return (options || []).map((option) => {
		if (typeof option === 'string') {
			return { value: option, label: option };
		}
		return {
			value: String(option.value ?? option.id ?? ''),
			label: option.label || option.name || String(option.value ?? ''),
		};
	});
};

// A standalone checkbox (e.g. a consent box) is parsed as `checkbox` with no option list (EN-893).
export const isSingleCheckboxField = (field) => {
	return field?.field_type === 'checkbox' && normalizeFieldOptions(field.options).length === 0;
};

// Whether a review form answer is still blank: no option picked, or no text beyond whitespace. Mirrors the empty check
// of ApplicationAnswerService::validateApprovalAnswers() in PHP.
export const isAnswerEmpty = (item) => {
	if (OPTION_FIELD_TYPES.includes(item.field?.field_type)) {
		return !Array.isArray(item.answer_value) || !item.answer_value.some((value) => value !== null && value !== '');
	}

	return !item.answer || !String(item.answer).trim();
};

// The toast for a review form that failed validation. A missing location can only be fixed on the profile.
export const validationFailureMessage = (answers, errors) => (
	answers.some((item) => LOCATION_FIELD_SLUGS.includes(item.catalog_slug) && errors[item.field?.field_name])
		? 'Please update your profile with your location to fill required fields.'
		: 'Please fix the highlighted fields and try again.'
);

// Mirrors PhoneNumberService::looksLikePhone() in PHP — cheap structural check
// for use in the AutoApply review screen. Rejects emails, alphabetic strings,
// and digit counts outside the ITU E.164 range (7–15).
export const looksLikePhone = (value) => {
	if (value == null) {
		return false;
	}

	const trimmed = String(value).trim();

	if (trimmed === '' || trimmed.includes('@')) {
		return false;
	}

	if (/[A-Za-z]/.test(trimmed)) {
		return false;
	}

	const digits = trimmed.replace(/\D+/g, '');
	return digits.length >= 7 && digits.length <= 15;
};

// The review form's shape for the answers the API generated for an application. `needsInputFieldNames` names the
// fields only the user can answer (EN-1246), which the AutoApply Queue review asks for first.
export const formatAnswers = (answers, needsInputFieldNames = []) => {
	return answers.map((answer) => ({
		uuid: answer.uuid,
		question: answer.field?.label || '',
		answer: answer.answer_text || '',
		answer_value: answer.answer_value || null,
		field: answer.field,
		source: answer.source,
		is_profile_field: answer.is_profile_field,
		catalog_slug: answer.field?.catalog_slug || null,
		needs_input: needsInputFieldNames.includes(answer.field?.field_name),
	}));
};
